// extracted by mini-css-extract-plugin
module.exports = {"badge":"FollowsYouBadge_badge__lYxUo","mobile":"FollowsYouBadge_mobile__3p5j0"};